<script setup lang="ts">
import { computed } from 'vue'
import { PickedUpload } from '@/components/upload/UploadPicker.vue'
import useContentTypes, { ContentTypeGroup } from '@/composables/useContentTypes'
import CreateImageStepUpload from '@/components/stepUpload/CreateImageStepUpload.vue'
import CreateVideoStepUpload from '@/components/stepUpload/CreateVideoStepUpload.vue'

const props = defineProps<{
  stepId: string
  upload: PickedUpload
  onCreated?: () => void
}>()

const { getContentTypeGroup } = useContentTypes()
const type = computed(() => getContentTypeGroup(props.upload.contentType))
</script>

<template>
  <create-image-step-upload
    v-if="type == ContentTypeGroup.IMAGE"
    :step-id="props.stepId"
    :upload="props.upload"
    v-bind="$attrs"
    @created="props.onCreated?.()"
  />
  <create-video-step-upload
    v-if="type == ContentTypeGroup.VIDEO_FOR_BROWSER"
    :step-id="props.stepId"
    :upload="props.upload"
    v-bind="$attrs"
    @created="props.onCreated?.()"
  />
</template>

<style scoped lang="scss"></style>
